import { ACTIVITY_LOG_LIFECYCLE_STATUS_VALUES } from "./monitoringEnums";
import type { MonitorStatusLabelKey } from "./monitoringEnums";
import type { MonitoringActivityLogRun } from "./types";

export function isLifecycleActivityLogRow(
  run: MonitoringActivityLogRun
): boolean {
  return ACTIVITY_LOG_LIFECYCLE_STATUS_VALUES.includes(
    run.monitor_status as (typeof ACTIVITY_LOG_LIFECYCLE_STATUS_VALUES)[number]
  );
}

export function formatLifecycleStatusText(
  run: MonitoringActivityLogRun,
  statusLabels: Partial<Record<MonitorStatusLabelKey, string>>
): string {
  const status = run.monitor_status as MonitorStatusLabelKey;
  return statusLabels[status] ?? run.monitor_status;
}

export function formatLifecycleActorText(
  run: MonitoringActivityLogRun
): string | null {
  const actorName = run.actor_name?.trim();
  const actorEmail = run.actor_email?.trim();
  if (!actorName && !actorEmail) {
    return null;
  }
  if (actorName && actorEmail) {
    return `${actorName} (${actorEmail})`;
  }
  return actorName || actorEmail || null;
}
